import { render, staticRenderFns } from "./LkBurgerMenu.vue?vue&type=template&id=064ccaf5&"
import script from "./LkBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./LkBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./LkBurgerMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkBurgerMenu.vue
// module id = 1597
// module chunks = 0